/**
 * @file logout.component.tsx
 * @description Компонент для отображения иконки выхода из аккаунта.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 */

import { IIconProps } from '@src/types';

export const LogoutIcon = ({ size = '1.5878vmin', className = '' }: IIconProps) => {
    return (
        <div className={className}>
            <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path d="M11 14H1V2h10v2H3v8h8v2Z"></path>
                <path d="m15 8-3 3V9H5V7h7V5l3 3Z"></path>
            </svg>
        </div>
    );
};
